import { createStore } from '@aibees/shared/store';
import { SearchFiltersStoreData as StoreData } from './types';

const useSearchFiltersStore = createStore<StoreData>(
  'search-filters',
  (set) => ({
    current: false,
    setCurrent: (current) => set({ current }),

    recordManagementOpen: false,
    setRecordManagementOpen: (v) => set({ recordManagementOpen: v }),

    viewAllLists: false,
    setViewAllLists: (viewAll) => set({ viewAllLists: viewAll }),

    viewAllLabels: false,
    setViewAllLabels: (viewAll) => set({ viewAllLabels: viewAll }),

    filters: [],
    setFilters: (filters) => set({ filters }),

    selectedItem: undefined,
    setSelectedItem: (selectedItem) => set({ selectedItem }),

    selectedItemId: undefined,
    setSelectedItemId: (selectedItemId) => set({ selectedItemId }),
  })
);

export default useSearchFiltersStore;
